// Optional Application Insights telemetry. Activates only when the build has
// VITE_APPINSIGHTS_CONNECTION_STRING set (an Azure App Insights resource's
// connection string, provided via the deploy workflow). Without it every call
// is a no-op, so local dev, tests, and the demo build pay zero cost — the SDK
// is dynamically imported and stays out of the main bundle entirely.
//
// The prod CSP already allows the ingestion hosts
// (https://*.in.applicationinsights.azure.com), so enabling telemetry later is
// just: create the resource, add the connection string to the workflow, done.

const CONN = import.meta.env.VITE_APPINSIGHTS_CONNECTION_STRING;

let aiPromise = null;

function getAi() {
  if (!CONN) return null;
  if (!aiPromise) {
    aiPromise = import('@microsoft/applicationinsights-web')
      .then(({ ApplicationInsights }) => {
        const ai = new ApplicationInsights({
          config: {
            connectionString: CONN,
            // The PQ holds client financial data — keep collection to timings
            // and our explicit events; no cookies, no user tracking.
            disableCookiesUsage: true,
            enableAutoRouteTracking: false,
          },
        });
        ai.loadAppInsights();
        return ai;
      })
      .catch(err => {
        console.warn('Telemetry disabled (SDK failed to load):', err);
        return null;
      });
  }
  return aiPromise;
}

// Fire-and-forget custom event. `properties` values should be strings/numbers;
// never pass client data (names, amounts) — status codes, durations, counts.
export function trackEvent(name, properties = {}) {
  const p = getAi();
  if (!p) return;
  p.then(ai => {
    if (ai) ai.trackEvent({ name }, properties);
  });
}
